import React from 'react';

import { MYPAGE_ROUTER } from '~/constants/router';
import ShoppingCartLink from '~/domains/cart/ShoppingCartLink';
import { useLinkComponent } from '~/hooks/mobileApp';

import SearchIcon from '~/assets/icons/gnb/ic_magnifier_line_24x24.svg';
import MypageIcon from '~/assets/icons/gnb/ic_user_line_24x24.svg';

const RightMenu = ({ SearchLink }: { SearchLink?: React.ReactNode }) => {
  const LinkComponent = useLinkComponent();

  return (
    <div className="ml-8 flex items-center gap-2 text-transparent">
      {SearchLink ? (
        <span className="flex items-center p-6">{SearchLink}</span>
      ) : (
        <LinkComponent href="/search">
          <span className="p-6">
            <SearchIcon />
          </span>
        </LinkComponent>
      )}
      <ShoppingCartLink />
      <LinkComponent href={MYPAGE_ROUTER.root}>
        <span className="p-6">
          <MypageIcon />
        </span>
      </LinkComponent>
    </div>
  );
};

export default RightMenu;
